import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

const SearchField = ({ doSearch, ...rest }) => {
  const [text, setText] = useState('');
  const handleChange = (e) => {
    const { value } = e.target;
    setText(value);
    doSearch(value);
  };
  return (
    <TextField
      {...rest}
      value={text}
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default React.memo(SearchField);
